import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SpikesGearHeader.css';

const SpikesGearHeader = () => {
  const location = useLocation();
  const isFulfillment = location.pathname.startsWith('/spikes-gear/fulfillment');

  return (
    <div className="spikes-gear-header">
      <div className="spikes-gear-header-inner">
        <div className="spikes-gear-header-brand">
          <span className="spikes-gear-header-icon">👕</span>
          <div className="spikes-gear-header-titles">
            <h1>Spikes Gear</h1>
            <p>Order Management System</p>
          </div>
        </div>
        <nav className="spikes-gear-tabs">
          <Link to="/spikes-gear" className={`spikes-gear-tab ${!isFulfillment ? 'active' : ''}`}>
            Orders
          </Link>
          <Link
            to="/spikes-gear/fulfillment"
            className={`spikes-gear-tab ${isFulfillment ? 'active' : ''}`}
          >
            Fulfillment
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default SpikesGearHeader;
